import { makeAutoObservable } from 'mobx';
import { getTherapies, getTherapyComments } from '../API/therapyApi';
import { getIllnessProfiles } from '../API/illnessProfileApi';
import { getPatients } from '../API/patientApi';

export default class MedicalStore {
    constructor() {
        this._therapies = [];
        this._illnessProfiles = [];
        this._patients = [];
        // this._comments = [];
        makeAutoObservable(this);
    }

    setTherapies(therapies) {
        this._therapies = therapies;
    }

    setIllnessProfiles(illnessProfiles) {
        this._illnessProfiles = illnessProfiles;
    }

    setPatients(patients) {
        this._patients = patients;
    }

    // setComments(comments) {
    //     this._comments = comments;
    // }

    get therapies() {
        return this._therapies;
    }

    get illnessProfiles() {
        return this._illnessProfiles;
    }

    get patients() {
        return this._patients;
    }

    // get comments() {
    //     return this._comments;
    // }

    async fetchTherapies() {
        try {
            const response = await getTherapies();
            this.setTherapies(response.results);
            console.log('Получены терапии:', this._therapies);
        } catch (error) {
            console.error('Ошибка загрузки терапий:', error);
        }
    }

    async fetchIllnessProfiles() {
        try {
            const response = await getIllnessProfiles();
            this.setIllnessProfiles(response);
            // console.log('Получены профили болезней:', this._illnessProfiles);
        } catch (error) {
            console.error('Ошибка загрузки профилей болезней:', error);
        }
    }

    async fetchPatients() {
        try {
            const response = await getPatients();
            this.setPatients(response.results);
            console.log('Получены пациенты:', this._patients);
        } catch (error) {
            console.error('Ошибка загрузки пациентов:', error);
        }
    }

    // async fetchComments(therapyId) {
    //     try {
    //         const response = await getTherapyComments(therapyId);
    //         this.setComments(response.results);
    //         console.log('Получены комментарии терапии:', this._comments);
    //     } catch (error) {
    //         console.error('Ошибка загрузки  комментариев:', error);
    //     }
    // }
}

